"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstanceConnector = void 0;
const installInstanceConnector_1 = require("./instance-connector/installInstanceConnector");
class InstanceConnector {
    constructor({ type, disabled }) {
        this.disabled = false;
        this.root = null;
        this.instanceList = [];
        this.type = type;
        if (disabled) {
            this.disabled = true;
        }
    }
    /**
     * Add context
     * @param context: instances can access context by this scope
     */
    addContext(context) {
        this.context = context;
        return this;
    }
    /**
     * Add Root instance
     */
    addRoot(root) {
        this.root = root;
        this.instanceList.push(this.root);
        return this;
    }
    /**
     * Add library instances
     */
    // tslint:disable-next-line
    addLibrary(plugin) {
        const isArray = Array.isArray(plugin);
        const pluginToPush = isArray ? plugin : [plugin];
        this.instanceList.push(...pluginToPush);
        return this;
    }
    /**
     * Connect Root instance with library-instances
     */
    connect() {
        if (this.instanceList.length > 0 && !this.disabled) {
            return (0, installInstanceConnector_1.installInstanceConnector)(this.type, this.instanceList, this.context);
        }
        return (0, installInstanceConnector_1.installMockedInstanceConnector)(this.type);
    }
}
exports.InstanceConnector = InstanceConnector;
//# sourceMappingURL=InstanceConnector.js.map